import React, { Component, Fragment } from 'react';
import {
  Card, CardBody, Col, CardHeader, Row
} from 'reactstrap';

import ReactHighChart from 'react-highcharts/ReactHighcharts.src';

import ChartReportApi from 'apis/reports/ChartReport';
import { pieChartConfig } from 'constants/chartsConstants';
import { generateChartConfig } from 'utils/generateChartConfig';
import Filters from './Filters';
import ChartSkeleton from '../skeleton-uis/charts/ChartSkeleton';

class ChartReport extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      filter: '',
      filters: null,
      series: {
        xAxis: [],
        ageData: [],
        genderData: []
      },
    }
  }

  componentWillMount = () => {
    const { filters } = this.props;

    if (filters) {
      this.setState({ filter: filters[0] }, this.updateChart);
    } else {
      this.updateChart();
    }
  }

  componentDidUpdate = (prevProps) => {
    const { startDate, endDate } = this.props;
    if (startDate !== prevProps.startDate || endDate !== prevProps.endDate) {
      if ((startDate && endDate) || (!startDate && !endDate)) {
        this.updateChart();
      }
    }
  }

  updateChart = () => {
    const { startDate, endDate, questionId, category, filterType, dataType: chart_type } = this.props;
    const { filter } = this.state;
    const start_date = startDate;
    const end_date = endDate;
    let filters = null;
    if (filterType) {
      filters = {};
      filters[filterType] = filter;
    }

    this.setState({ isLoading: true });

    ChartReportApi.getAll(questionId, filters, category, chart_type, start_date, end_date).then(({ data }) => {

      this.setState((prevState) => ({
        series: data, isLoading: false,
      }));
    }).catch(e => {
      console.log(e)
      this.setState({ isLoading: false })
    });
  }

  onFilter = (filterValue) => {
    const { filter } = this.state;
    if (filterValue != filter) {
      this.setState({ filter: filterValue }, this.updateChart);
    }
  }

  renderChartBody = () => {
    const { isLoading, filter, series } = this.state;
    const {
      titleText, subtitleText, chartType, filters, stacked, colors, axisTitle, percentage, height
    } = this.props;
    const { xAxis, age_data: ageData, gender_data: genderData } = series;
    const ageSeriesData = { xAxis, series: ageData };
    const genderSeriesData = { xAxis, series: [{ ...genderData, ...pieChartConfig }] };
    const genderChartConfig = generateChartConfig({
      seriesData: genderSeriesData,
      chartType: 'pie',
      titleText: '',
      subtitleText: '',
      yAxisTitle: axisTitle,
      stacked,
      colors,
      percentage,
      height
    });

    const genderDataConfig = {
      ...genderChartConfig,
      legend: {
        ...genderChartConfig.legend,
        align: 'right',
        itemDistance: 5,
        verticalAlign: 'bottom'
      },
    };

    let ageDataConfig = generateChartConfig({
      seriesData: ageSeriesData,
      chartType: 'bar',
      titleText: '',
      subtitleText: '',
      yAxisTitle: axisTitle,
      stacked: true,
      colors,
      percentage,
      height
    });

    ageDataConfig = {
      ...ageDataConfig,
      chart: {
        ...ageDataConfig.chart,
        marginRight: 20
      },
      legend: {
        enabled: false,
      },
    }

    if (isLoading) {
      return <ChartSkeleton chartType={chartType} />;
    }

    return (
      <Fragment>
        <Row>
          <Col xs={12} xl={6} sm={12} md={6} lg={6} className="p-0 my-0">
            <ReactHighChart
              config={genderDataConfig} />
          </Col>
          <Col xs={12} xl={6} sm={12} md={6} lg={6} className="p-0 my-0" style={{ position: 'relative', left: '-9px' }}>
            <ReactHighChart
              config={ageDataConfig} />
          </Col>
        </Row>
        {filters && (<span className="filter-container">
          <Filters filters={filters} onFilter={this.onFilter} filter={filter} />
        </span>)}
      </Fragment>
    )
  }

  renderChartTitle = () => {
    const { isLoading } = this.state;
    const { titleText, subtitleText } = this.props;

    if (isLoading) return null;

    return (
      <Fragment>
        <div style={{
          color: "#29508B",
          fontSize: "14px",
          fontWeight: 600
        }}>{titleText}</div>
        <div style={{
          color: "#29508B",
          fontSize: "12px"
        }}>{subtitleText}</div>
      </Fragment>
    )
  }

  render() {
    const { headTitle } = this.props;

    return (
      <Row className="w-100">
        <Col className="p-0 my-0">
          <Card className="rounded-0">
            {headTitle && (
              <CardHeader className="chart-group-head text-center">
                {headTitle}
              </CardHeader>)}
            <CardBody>
              {this.renderChartTitle()}
              <Col>{this.renderChartBody()}</Col>
            </CardBody>
          </Card>
        </Col>
      </Row>
    )
  }
}

export default ChartReport;



// WEBPACK FOOTER //
// ./src/components/charts/ParticipationChart.js